// @flow
import * as React from 'react';

import { Link } from 'react-router-dom';

import { selectCartUUID } from '@gandi/cart';
import type {
  FavoriteContact,
  ContactRole,
} from '@gandi/redux-resource-contactbook';
import { useTranslator } from '@gandi/translate';
import { Base, Text } from '@gandi/ui';

import { useAppSelector } from 'src/hooks';

import { getModifyContactUrl } from '../../../../modules/helpers';
import type { CreateOrTransfer } from '../../../../types';

import ContactAddress from './ContactAddress';
import ContactName from './ContactName';
import ContactPrivacyOptions from './ContactPrivacyOptions';

type Props = {
  contact: FavoriteContact,
  role: ContactRole,
  process: CreateOrTransfer,
  readOnly: boolean,
};

function RoleContact({
  contact,
  role,
  process,
  readOnly,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const cartId = useAppSelector(selectCartUUID);

  const footer =
    role === 'owner' ? (
      <Text color="light">
        {__('Can be changed in the shopping cart overview')}
      </Text>
    ) : (
      !readOnly && (
        <Link to={getModifyContactUrl(cartId, process, role)}>
          {__('Update')}
        </Link>
      )
    );

  const baseArgs = {
    paddingLeft: 'small',
    paddingRight: 'small',
    paddingBottom: 'small',
    backgroundColor: 'grey-lighter',
  };

  const isolatedBlockArgs = {
    padding: 'small',
    backgroundColor: 'grey-lighter',
  };

  return (
    <>
      <Base {...baseArgs}>
        <ContactName contact={contact} />
      </Base>
      <Base {...baseArgs}>
        <ContactAddress contact={contact} />
      </Base>
      <Base {...baseArgs} paddingBottom="small">
        {/* $FlowFixMe[prop-missing] */}
        {/* $FlowFixMe[incompatible-type] */}
        <ContactPrivacyOptions contact={contact} />
      </Base>

      <Base {...isolatedBlockArgs}>{footer}</Base>
    </>
  );
}

export default (React.memo<Props>(RoleContact): React.ComponentType<Props>);
